module.exports = __webpack_public_path__ + "img/eb0c1e7.jpg";